/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isbot } from 'isbot';
export const getAllPaths = (obj, key, prev = '') => {
    //TODO : obj : recursive object
    const result = [];
    for (const k in obj) {
        const path = prev + (prev ? '.' : '') + k;
        if (k == key) {
            result.push(`${path.replace(`.${key}`, '')}: ${obj[k]}`);
        }
        else if (typeof obj[k] == 'object') {
            result.push(...getAllPaths(obj[k], key, path));
        }
    }
    return result;
};
const getCookie = (name) => {
    if (typeof document === 'undefined') {
        return null;
    }
    const cookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));
    if (!cookie) {
        return null;
    }
    return cookie.split('=')[1];
};
export const uid = () => { var _a; return window && ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('user_id')); };
export const cid = () => {
    const gaCookie = getCookie('_ga');
    if (gaCookie) {
        const pattern = /(\d+\.\d+)$/;
        const match = gaCookie.match(pattern);
        if (match) {
            return match[0];
        }
        return '';
    }
    return '';
};
export const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url === null || base64Url === void 0 ? void 0 : base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split('')
        .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
};
export const isAbsoluteURL = (url) => /^https:\/\//i.test(url);
export const addSearchParam = (url, key, value) => {
    if (isAbsoluteURL(url)) {
        const urlObject = new URL(url);
        urlObject.searchParams.set(key, value);
        return urlObject.toString();
    }
    else {
        const urlObject = new URL(url, 'https://any.com');
        urlObject.searchParams.set(key, value);
        return `${urlObject.pathname}${urlObject.search}${urlObject.hash}`;
    }
};
export const handleWithTrackingHref = (e, medium) => {
    const { userAgent } = navigator;
    if (!isbot(userAgent)) {
        e.href = addSearchParam(e.href, 'm', medium);
    }
};
